import { RichTextResolver, RichTextSchema } from '@storyblok/js';
import { strippedURL } from './strippedURL';

const textAlignAttrs = (textAlign?: string | null) => {
  if (!textAlign) return undefined;

  return {
    style: `text-align: ${textAlign}`,
    class: `rte-align-${textAlign}`,
  };
};

const richTextResolver = new RichTextResolver({
  nodes: {
    ...RichTextSchema.nodes,
    paragraph: (node) => {
      const attrs = textAlignAttrs(node.attrs?.textAlign);
    
      return attrs
        ? { tag: [{ tag: 'p', attrs }] }
        : RichTextSchema.nodes.paragraph(node);
    },
    heading: (node) => {
      const attrs = textAlignAttrs(node.attrs?.textAlign);
      if (!attrs) return RichTextSchema.nodes.heading(node);

      return {
        tag: [{ tag: `h${node.attrs?.level}`, attrs }],
      };
    },
  },
  marks: RichTextSchema.marks,
});

export function useRenderRichText (text) {
  if (!text?.content?.length) return '';

  const replacer = (match, p1) => match.replace(p1, strippedURL(p1));

  return richTextResolver.render(text).replaceAll(/href=["'](.*?)["']/g, replacer);
}
